import React from "react";
import styles from "./package-tile.module.css";
import { withSafeRender } from "../../atoms/safe-render";

/**
 * GH3's two labels — the package name and its channel count. A server component, and there is no
 * measurement left to take.
 */

export interface TileLabelsProps {
  /** Already reduced to plain text by the server caller. */
  name: string;
  /** GH2's content-managed channel count, e.g. "90+ channels". */
  countText?: string;
}

function TileLabelsImpl({ name, countText }: TileLabelsProps) {
  return (
    <span className={styles.labels} data-cl-labels="">
      <span className={styles.name}>{name}</span>
      {countText && <span className={styles.count}>{countText}</span>}
    </span>
  );
}
export const TileLabels = withSafeRender(TileLabelsImpl, "TileLabels");

export default TileLabels;
